import type * as React from "react"

import { cn } from "@/lib/utils"

interface AttributesContainerProps {
  children: React.ReactNode
  className?: string
}

export default function AttributesContainer({
  children,
  className,
}: AttributesContainerProps) {
  return <div className={cn("flex flex-col gap-4", className)}>{children}</div>
}
